import React from 'react'
import PropTypes from 'prop-types'
import Style from './style'

const defaultFunction = () => {}
const defaultString = ''

class InputNumber extends React.Component {
  render () {
    const props = Object.assign({}, this.props)
    return (
      <Style>
        <section className={'input-box '.concat(props.disabled ? ' disabled ' : defaultString).concat(props.className ? props.className : defaultString)}>
          <label>{props.currentValue ? props.currentValue : 0}</label>
          <section className='button-container'>
            <svg aria-hidden='true' onClick={!props.disabled ? (event) => props.handleUpClick(event) : defaultFunction} focusable='false' data-prefix='fas' data-icon='caret-up' role='img' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 320 512'><path fill='currentColor' d='M288.662 352H31.338c-17.818 0-26.741-21.543-14.142-34.142l128.662-128.662c7.81-7.81 20.474-7.81 28.284 0l128.662 128.662c12.6 12.599 3.676 34.142-14.142 34.142z' /></svg>
            <svg aria-hidden='true' onClick={!props.disabled ? (event) => props.handleDownClick(event) : defaultFunction} focusable='false' data-prefix='fas' data-icon='caret-down' role='img' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 320 512'><path fill='currentColor' d='M31.3 192h257.3c17.8 0 26.7 21.5 14.1 34.1L174.1 354.8c-7.8 7.8-20.5 7.8-28.3 0L17.2 226.1C4.6 213.5 13.5 192 31.3 192z' /></svg>
          </section>
        </section>
        <label>{props.label}</label>
      </Style>
    )
  }
}

InputNumber.propTypes = {
  handleUpClick: PropTypes.func.isRequired,
  handleDownClick: PropTypes.func.isRequired,
  currentValue: PropTypes.number.isRequired,
  label: PropTypes.string
}

export default InputNumber
